import { ReactNode } from 'react';

import {
  ONLINE_MEDIA,
  ONLINE_MEDIA_CLIPPING,
  SOCIAL_MEDIA,
  SOCIAL_MEDIA_CAMPAIGN,
  SOCIAL_MEDIA_COMMUNITY,
  SOCIAL_MEDIA_CONTENT,
  SOCIAL_MEDIA_CONVERSATION,
  SOCIAL_MEDIA_OVERVIEW,
  SOCIAL_MEDIA_COMPARISON,
  STREAM_PANEL,
  STREAM_PANEL_ONLINE_MEDIA,
  STREAM_PANEL_SOCIAL_MEDIA,
  SETTINGS,
  ONLINE_MEDIA_STATISTIC,
  CUSTOM_DASHBOARD,
  ONLINE_MEDIA_COMPARISON,
  SOCIAL_MEDIA_SNA,
  SOCIAL_MEDIA_DNA,
  PEOPLE_PANEL,
  STREAM_PANEL_OFFLINE_MEDIA,
  OFFLINE_MEDIA,
  OFFLINE_MEDIA_STATISTIC,
  CUSTOMIZATION,
  CUSTOM_REPORT,
  SOCIAL_MEDIA_CLUSTERING,
  OFFLINE_MEDIA_CLIPPING,
  OFFLINE_MEDIA_COMPARISON,
  GOOGLE_REVIEW,
  GOOGLE_REVIEW_STATISTIC,
  GOOGLE_REVIEW_COMPARISON,
  OVERVIEW,
  ECOMMERCE,
  ECOMMERCE_STATISTIC,
  ECOMMERCE_COMPARISON,
  ECOMMERCE_STREAM
} from 'src/route';
import GridViewIcon from '@mui/icons-material/GridView';
//import SummarizeIcon from '@mui/icons-material/Summarize';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import MessageIcon from '@mui/icons-material/Message';
import ArticleIcon from '@mui/icons-material/Article';
import SettingsIcon from '@mui/icons-material/Settings';
import FeedIcon from '@mui/icons-material/Feed';

import ReviewsIcon from '@mui/icons-material/Reviews';
import DashboardIcon from '@mui/icons-material/Dashboard';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';

export interface MenuItem {
  link?: string;
  icon?: ReactNode;
  badge?: string;
  items?: MenuItem[];
  name: string;
}

export interface MenuItems {
  items: MenuItem[];
  heading?: string;
}

export const defaultMenuItems: MenuItems[] = [
  {
    heading: 'MAIN',
    items: [
      {
        name: 'Main Overview',
        link: OVERVIEW,
        icon: DashboardIcon
      },
      {
        name: 'Customization',
        link: CUSTOMIZATION,
        icon: GridViewIcon,
        items: [
          {
            name: 'Dashboard',
            link: CUSTOM_DASHBOARD
          },
          { name: 'Report', link: CUSTOM_REPORT }
        ]
      },
      {
        name: 'Stream Panel',
        link: STREAM_PANEL,
        icon: ViewStreamIcon,
        items: [
          {
            name: 'Social Media',
            link: STREAM_PANEL_SOCIAL_MEDIA
          },
          {
            name: 'Online Media',
            link: STREAM_PANEL_ONLINE_MEDIA
          },
          {
            name: 'People Panel',
            link: PEOPLE_PANEL
          },
          // {
          //   name: 'Others Media',
          //   link: STREAM_PANEL_OFFLINE_MEDIA
          // }
          // TODO: Separate Offline Media for Existing Projects
          {
            name: 'Print Media',
            link: `${STREAM_PANEL_OFFLINE_MEDIA}?type=print`
          },
          {
            name: 'Broadcast Media',
            link: `${STREAM_PANEL_OFFLINE_MEDIA}?type=broadcast`
          }
        ]
      }
      // {
      //   name: 'AI Assistant',
      //   link: CHAT_NOW,
      //   icon: ForumIcon,
      //   items: [
      //     { name: 'New Chat', link: CHAT_NOW_NEW_CHAT }
      //     // { name: 'Chat History', link: CHAT_NOW_CHAT_HISTORY }
      //   ]
      // }
    ]
  },
  {
    heading: 'ANALYTIC',
    items: [
      {
        name: 'Social Media',
        link: SOCIAL_MEDIA,
        icon: MessageIcon,
        items: [
          {
            name: 'Overview',
            link: SOCIAL_MEDIA_OVERVIEW
          },
          {
            name: 'Content',
            link: SOCIAL_MEDIA_CONTENT
          },
          {
            name: 'Community',
            link: SOCIAL_MEDIA_COMMUNITY
          },
          {
            name: 'Campaign',
            link: SOCIAL_MEDIA_CAMPAIGN
          },
          {
            name: 'Conversation',
            link: SOCIAL_MEDIA_CONVERSATION
          },
          {
            name: 'Comparison',
            link: SOCIAL_MEDIA_COMPARISON
          },
          {
            name: 'SNA',
            link: SOCIAL_MEDIA_SNA
          },
          {
            name: 'DNA',
            link: SOCIAL_MEDIA_DNA
          },
          {
            name: 'Clustering',
            link: SOCIAL_MEDIA_CLUSTERING
          }
        ]
      },
      {
        name: 'Online Media',
        link: ONLINE_MEDIA,
        icon: ArticleIcon,
        items: [
          {
            name: 'Statistic',
            link: ONLINE_MEDIA_STATISTIC
          },
          {
            name: 'Clipping',
            link: ONLINE_MEDIA_CLIPPING
          },
          {
            name: 'Comparison',
            link: ONLINE_MEDIA_COMPARISON
          }
        ]
      },
      {
        name: 'Print Media',
        link: OFFLINE_MEDIA,
        icon: FeedIcon,
        items: [
          {
            name: 'Statistic',
            link: `${OFFLINE_MEDIA_STATISTIC}?type=print`
          },
          {
            name: 'Clipping',
            link: `${OFFLINE_MEDIA_CLIPPING}?type=print`
          },
          {
            name: 'Comparison',
            link: `${OFFLINE_MEDIA_COMPARISON}?type=print`
          }
        ]
      },
      {
        name: 'Broadcast Media',
        link: OFFLINE_MEDIA,
        icon: VideoFileIcon,
        items: [
          {
            name: 'Statistic',
            link: `${OFFLINE_MEDIA_STATISTIC}?type=broadcast`
          },
          {
            name: 'Clipping',
            link: `${OFFLINE_MEDIA_CLIPPING}?type=broadcast`
          },
          {
            name: 'Comparison',
            link: `${OFFLINE_MEDIA_COMPARISON}?type=broadcast`
          }
        ]
      },
      {
        name: 'E-Commerce',
        link: ECOMMERCE,
        icon: ShoppingBagIcon,
        items: [
          {
            name: 'Stream',
            link: ECOMMERCE_STREAM
          },
          {
            name: 'Statistic',
            link: ECOMMERCE_STATISTIC
          },
          {
            name: 'Comparison',
            link: ECOMMERCE_COMPARISON
          }
        ]
      },
      {
        name: 'Google Review',
        link: GOOGLE_REVIEW,
        icon: ReviewsIcon,
        items: [
          {
            name: 'Statistic',
            link: GOOGLE_REVIEW_STATISTIC
          },
          {
            name: 'Comparison',
            link: GOOGLE_REVIEW_COMPARISON
          }
        ]
      }
    ]
  },
  {
    heading: 'PREFERENCES',
    items: [
      {
        name: 'Settings',
        link: SETTINGS,
        icon: SettingsIcon
      }
    ]
  }
];

export const malaysiaMenuItems: MenuItems[] = [
  {
    items: [
      {
        name: 'Main Overview',
        link: OVERVIEW,
        icon: DashboardIcon
      }
    ]
  },
  {
    heading: 'MAINSTREAM MEDIA',
    items: [
      {
        name: 'Print Media',
        icon: FeedIcon,
        items: [
          {
            name: 'Stream Panel',
            link: `${STREAM_PANEL_OFFLINE_MEDIA}?type=print`
          },
          {
            name: 'Statistic',
            link: `${OFFLINE_MEDIA_STATISTIC}?type=print`
          },
          {
            name: 'Clipping',
            link: `${OFFLINE_MEDIA_CLIPPING}?type=print`
          },
          {
            name: 'Comparison',
            link: `${OFFLINE_MEDIA_COMPARISON}?type=print`
          }
        ],
        link: OFFLINE_MEDIA
      },
      {
        name: 'Broadcast Media',
        icon: VideoFileIcon,
        items: [
          {
            name: 'Stream Panel',
            link: `${STREAM_PANEL_OFFLINE_MEDIA}?type=broadcast`
          },
          {
            name: 'Statistic',
            link: `${OFFLINE_MEDIA_STATISTIC}?type=broadcast`
          },
          {
            name: 'Clipping',
            link: `${OFFLINE_MEDIA_CLIPPING}?type=broadcast`
          },
          {
            name: 'Comparison',
            link: `${OFFLINE_MEDIA_COMPARISON}?type=broadcast`
          }
        ],
        link: OFFLINE_MEDIA
      },
      {
        name: 'Online News',
        icon: ArticleIcon,
        items: [
          {
            name: 'Stream Panel',
            link: STREAM_PANEL_ONLINE_MEDIA
          },
          {
            name: 'Statistic',
            link: ONLINE_MEDIA_STATISTIC
          },
          {
            name: 'Clipping',
            link: ONLINE_MEDIA_CLIPPING
          },
          {
            name: 'Comparison',
            link: ONLINE_MEDIA_COMPARISON
          }
        ],
        link: ONLINE_MEDIA
      }
    ]
  },
  {
    heading: 'DIGITAL MEDIA',
    items: [
      {
        name: 'Social Media',
        icon: MessageIcon,
        link: SOCIAL_MEDIA,
        items: [
          {
            name: 'Stream Panel',
            link: STREAM_PANEL_SOCIAL_MEDIA
          },
          {
            name: 'Overview',
            link: SOCIAL_MEDIA_OVERVIEW
          },
          {
            name: 'Content',
            link: SOCIAL_MEDIA_CONTENT
          },
          {
            name: 'Community',
            link: SOCIAL_MEDIA_COMMUNITY
          },
          {
            name: 'Campaign',
            link: SOCIAL_MEDIA_CAMPAIGN
          },
          {
            name: 'Conversation',
            link: SOCIAL_MEDIA_CONVERSATION
          },
          {
            name: 'Comparison',
            link: SOCIAL_MEDIA_COMPARISON
          },
          {
            name: 'SNA',
            link: SOCIAL_MEDIA_SNA
          }
        ]
      },
      {
        name: 'Google Review',
        link: GOOGLE_REVIEW,
        icon: ReviewsIcon,
        items: [
          {
            name: 'Statistic',
            link: GOOGLE_REVIEW_STATISTIC
          },
          {
            name: 'Comparison',
            link: GOOGLE_REVIEW_COMPARISON
          }
        ]
      }
    ]
  },
  {
    heading: 'UTILITIES',
    items: [
      // {
      //   name: 'AI Assistant',
      //   link: CHAT_NOW,
      //   icon: ForumIcon,
      //   items: [
      //     { name: 'New Chat', link: CHAT_NOW_NEW_CHAT }
      //     // { name: 'Chat History', link: CHAT_NOW_CHAT_HISTORY }
      //   ]
      // },
      {
        name: 'Customization',
        link: CUSTOMIZATION,
        icon: GridViewIcon,
        items: [
          {
            name: 'Dashboard',
            link: CUSTOM_DASHBOARD
          },
          { name: 'Report', link: CUSTOM_REPORT }
        ]
      }
    ]
  },
  {
    items: [
      {
        name: 'Settings',
        link: SETTINGS,
        icon: SettingsIcon
      }
    ]
  }
];
